import { getData, postData } from "./apiService";
import { uploadFileToS3 } from "./fileService";


export const uploadAndRegisterFile = async (registrantId: string, file: File, registrationQuestionId: string) => {
    try {
      // Step 1: Get the pre-signed URL from the backend
      const { uploadUrl, s3_key } = await getRegistrantUploadUrl(registrantId, file, registrationQuestionId);
      
      // Step 2: Upload the file to S3
      const success = await uploadFileToS3(uploadUrl, file);
      
      if (success) {
        console.log('File uploaded successfully to S3!');
      } else {
        console.error('Failed to upload file');
      }
    } catch (error) {
      console.error('Error uploading and registering file:', error);
    }
  };
  
  // Request pre-signed URL
  export const getRegistrantUploadUrl = async (registrantId: string, file: File, registrationQuestionId: string) => {
    try {
      const response = await postData(`/registrants/${registrantId}/files`, {
        file_name: file.name,
        file_type: file.type,
        registration_question_id: registrationQuestionId,
      });
  
      return response.data as { uploadUrl: string; s3_key: string };
    } catch (error) {
      console.error('Error fetching file upload URL:', error);
      throw error;
    }
  };
  
  // Register file metadata in the database (called in upload and register file)
  const registerUploadedFile = async (registrantId: string, file: File, s3Key: string, registrationQuestionId: string) => {
    try {
      await postData(`/registrants/${registrantId}/files/register`, {
        file_name: file.name,
        file_type: file.type,
        s3_key: s3Key,
        registration_question_id: registrationQuestionId,
      });
      console.log('File metadata registered successfully');
    } catch (error) {
      console.error('Error registering file metadata:', error);
      throw error;
    }
  };

  export const getRegistrantFileUrl = async (fileId: string, download: boolean = false): Promise<string> => {
    try {
      const query = download ? '?download=true' : '';
      const response = await getData(`/registrants/files/${fileId}${query}`);
      return response.data.downloadUrl;
    } catch (error) {
      console.error('Error fetching file URL:', error);
      throw error;
    }
  };